import React, { useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Chip from '@material-ui/core/Chip';
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import styles from "assets/jss/material-kit-react/components/profileStyle.js";
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import swal from 'sweetalert'
import Axios from "axios";
import Config from "../../config.js"
const useStyles = makeStyles(styles);

export default function Profile(props) {
  const { user } = props;
  const classes = useStyles();
  const [state, setState] = React.useState({
    skills: user && user.skills,
    skill: "",
    skillLevel: "",
  });
  var Call = () => {
    Axios.post(Config.api + "Authentication/CompleteRegistration", {
      skills:state.skills,
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        swal("با موفقیت انجام شد.");
      }).catch((err) => {
        if (err&&err.response&&err.response.status&&err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
          else if(err&&err.response&& err.response.data&&err.response.data.fa_message){
          swal(err.response.data.fa_message);
          }
        else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }

  const handleTextBoxChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  const handleDropDownChange = (event) => {
    if (event.target.value == 'true' || event.target.value == 'false')
      setState({ ...state, [event.target.name]: Boolean(event.target.value) });
    else setState({ ...state, [event.target.name]: (event.target.value) });
  };
 
  const addToSkillList = () => {
    if (state.skillLevel == null || state.skill == "")
      return swal("هیچ یک از مقادیر نمی تواند خالی باشد.");
    state.skills.push(state.skill+" ("+state.skillLevel+")")
    setState({ ...state, "skills": state.skills })
    setState({ ...state, "skillLevel": null, "skill": "" })
  };
  const removeFromList = (source, tttt, valueToRemove) => {
    var e = source.filter(item => item !== valueToRemove)
    setState({ ...state, [tttt]: e })
  };

  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <Paper className={classes.paper} variant="outlined" >

            <GridContainer>
              <GridItem xs={12} sm={12} md={5}>
                <div className={classes.div}>
                  <Typography variant="h6" gutterBottom>
                    مهارت‌ها
      </Typography>
                  <div className={classes.formInput}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="skillLevel">میزان تسلط</InputLabel>
                      <Select
                        value={state.skillLevel}
                        onChange={handleDropDownChange}
                        inputProps={{
                          name: 'skillLevel',
                          id: 'skillLevel',
                        }}
                      >
                        <MenuItem value="">
                          <em>انتخاب کنید</em>
                        </MenuItem>
                        <MenuItem value="مسلط">
                          <em>مسلط</em>
                        </MenuItem>
                        <MenuItem value="آشنا">
                          <em>آشنا</em>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.formInput}>
                    <TextField id="standard-basic" name="skill" value={state.skill} onChange={handleTextBoxChange} label="عنوان مهارت" helperText="مثال: برنامه نویسی جاوا" />
                  </div>
                  <br />
                  <div className={classes.formInput}>
                    <Button variant="outlined" color="secondary" disableElevation onClick={addToSkillList}>
                      افزودن به لیست
</Button>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={7}>
                <div className={classes.div}>
                {user && state.skills.length > 0 ? (
                  <div className={classes.formInput+" "+classes.chipMargin}>
                        {user && state.skills.map((skill) => {
                          var inputProps = {
                          };
                          if(skill.indexOf("(مسلط)")==-1)
                          inputProps.variant='outlined'
                          return (
                            <Chip label={skill} onDelete={() => { removeFromList(state.skills, 'skills', skill) }} color="primary" {... inputProps} />
                          );
                        })}
                  </div>
                ) : <p><br/>موردی جهت نمایش وجود ندارد.</p>}
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.en +" " +classes.save}>
                <Button variant="contained" color="primary" disableElevation onClick={Call}>
                     ذخیره سازی
</Button>
                </div>
              </GridItem>
            </GridContainer>
          </Paper>
        </GridItem>
  
      </GridContainer>
    </form>
  );
}